module.exports = __webpack_public_path__ + "static/p1-a3b6abe3a50e62c7fb5e1b78f0d2225c.jpg";